import { mapAsync } from '@gcc/nodash';
import { get, map, keyBy, first, size } from 'lodash/fp';

import addDesign from '../actions/addDesign';
import loadDesign from '../actions/loadEstimate';
import selectEstimate from '../actions/selectEstimate';
import clearStore from '../actions/clearStore';
import globalError from '../actions/globalError';

import * as designBuilderApi from '../api/designBuilder';

const enhanceYourCalm = (calmRate, func) => async () => {
  const result = await func();
  await new Promise(r => setTimeout(r, calmRate));
  return result;
};

const mapWithKey = map.convert({ cap: false });

const loadSession = (sessionId, { designToAttach = '' } = {}) => (
  (dispatch) => {
    dispatch(clearStore());

    return designBuilderApi
      .loadSession(sessionId, { designToAttach })
      .then(async (session) => {
        const sequentialDesignLoads = mapWithKey((it, idx, data) => enhanceYourCalm(
          size(data) - 1 === idx ? 0 : 250,
          () => dispatch(loadDesign(it)),
        ))(get('designIds', session));

        return mapAsync(async it => it(), sequentialDesignLoads);
      })
      .then((designs) => {
        const keyedDesigns = keyBy('designId')(designs);

        if (keyedDesigns[designToAttach]) {
          dispatch(selectEstimate(designToAttach, { load: false }));
          return keyedDesigns[designToAttach];
        }
        const firstDesign = first(designs);
        if (firstDesign) {
          dispatch(selectEstimate(firstDesign.designId, { load: false }));
          return firstDesign;
        }
        return dispatch(addDesign());
      })
      .catch(err => dispatch(globalError({ err })));
  }
);

export default loadSession;
